class Select2Filters {
  constructor() {}

  init() {
    const _this = this;

    return new Promise((resolve) => {
      this.initSelect2();

      $(document).on('gform_post_render', function () {
        _this.initSelect2();
      });

      resolve();
    });
  }

  initSelect2() {
    const formElement = document.querySelector('select')?.closest('form');
    if (!formElement) return;
    $('select').select2({
      width: '100%',
      minimumResultsForSearch: Infinity,
      dropdownParent: formElement,
    });
  }
}

window.Select2Filters = new Select2Filters();
BarbaController.addObject(Select2Filters);
